import {useEffect, useRef, useState} from "react";
import axios from 'axios';
import {useDispatch} from "react-redux";
import Modal from "../../elements/Modal";
import {isJsonString} from "../../../functions/functions";
import {formValid, resetFieldsErrors} from "../../../functions/form";
import {setError} from "../../../slices/error/ErrorSlice";

export default function Unit() {
    const dispatch = useDispatch();

    const[list, setList] = useState([]);
    const[form, setForm] = useState({
        name: ''
    })
    const formRefs = useRef({
        name: useRef(null)
    });
    const[modalShow, setModalShow] = useState(false);
    const[modalDelShow, setModalDelShow] = useState(false);
    const[editId, setEditId] = useState(null);
    const[delId, setDelId] = useState(null);
    const[nameDel, setNameDel] = useState(null);

    useEffect(() => {
        getList();
    }, []);

    function modalShowToggler() {
        setModalShow(!modalShow);
    }

    function closeModalUnit() {
        setModalShow(!modalShow);
        resetForm();
        resetFieldsErrors(formRefs.current);
        setEditId(null);
    }

    function openModalDelHandler(e) {
        setDelId(Number(e.currentTarget.getAttribute('iid')));
        setNameDel(e.currentTarget.previousSibling.previousSibling.innerHTML)
        setModalDelShow(!modalDelShow);
    }

    function closeModalDelHandler() {
        setModalDelShow(!modalDelShow);
        setDelId(null);
        setNameDel(null);
    }

    function resetForm() {
        setForm({
            name: '',
        })
    }

    function getList() {
        axios.get('/api/unit-list')
            .then(res => {
                setList(res.data)
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }

    function getItemHandler(e) {
        const id = e.currentTarget.getAttribute('iid');
        setEditId(id);

        axios.get(`/api/unit/${id}`)
            .then(res => {
                setForm(res.data);
                modalShowToggler();
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }

    function createHandler() {
        axios.post('/api/unit/create', form)
            .then(res => {
                getList();
                closeModalUnit();
            })
            .catch((e) => {
                if(isJsonString(e.response.data.detail)) {
                    let objErr = JSON.parse(e.response.data.detail);
                    formValid(formRefs.current, objErr);
                } else {
                    dispatch(setError(e.response.data));
                }
            })
    }

    function editHandler() {
        axios.post(`/api/unit/${editId}/edit`, form)
            .then(res => {
                closeModalUnit();
                getList();
            })
            .catch(e => {
                if(isJsonString(e.response.data.detail)) {
                    let objErr = JSON.parse(e.response.data.detail);
                    formValid(formRefs.current, objErr);
                } else {
                    dispatch(setError(e.response.data));
                }
            })
    }

    function delHandler() {
        axios.delete(`/api/unit/${delId}/del`)
            .then(res => {
                closeModalDelHandler();
                getList();
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }

    function changeHandler(e) {
        let fieldName = e.target.name;
        let value = e.target.value;

        setForm({...form, [fieldName]: value});
    }

    let rows = list.map(item =>
        <tr key={item.id}>
            <td style={{width: 95}}>{item.id}</td>
            <td>{item.name}</td>
            <td iid={item.id} onClick={getItemHandler} style={{width: 95}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                     className="bi bi-pencil hover" viewBox="0 0 16 16">
                    <path
                        d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                </svg>
            </td>
            <td iid={item.id} onClick={openModalDelHandler} style={{width: 95}}>
                <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-trash hover red" fill="currentColor"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                    <path
                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                </svg>
            </td>
        </tr>
    )

    return(
        <>
            <Modal
                header = { editId ? 'Редактирование' : 'Добавить ед. изм.' }
                show={modalShow}
                closeHandler={closeModalUnit}
            >
                <div className="mb-3 row">
                    <label htmlFor="inputLogin" className="col-sm-3 col-form-label">Наименование</label>
                    <div className="col-sm-9">
                        <input type="text" name='name' className="form-control" id="name" ref={formRefs.current.name}
                               onChange={changeHandler} value={form.name}
                        />
                    </div>
                </div>

                <div className='modal-footer-custom d-grid gap-2 d-md-flex justify-content-md-end'>
                    <input type='button' className='btn mb-0 btn-success margin-botom'
                           onClick={ editId ? editHandler : createHandler}
                           value="Сохранить"/>
                    <input type='button' className='btn mb-0 btn-danger margin-botom' onClick={closeModalUnit}
                           value='Отмена'/>
                </div>
            </Modal>

            <Modal
                header='Удалить клиента'
                show={modalDelShow}
                closeHandler={closeModalDelHandler}
            >
                <div className="float-none">{nameDel}</div>
                <div className='modal-footer-custom d-grid gap-2 d-md-flex justify-content-md-end'>
                    <input type='button' className='btn mb-0 btn-success margin-botom'
                           onClick={delHandler}
                           value='Да'/>
                    <input type='button' className='btn mb-0 btn-danger margin-botom' onClick={closeModalDelHandler}
                           value='Нет'/>
                </div>
            </Modal>

            <h1>Единицы измерения</h1>

            <input type='button' className='btn btn-primary margin-botom' onClick={modalShowToggler} value='Добавить'/>

            <table className="table table-striped table-bordered">
                <thead>
                <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Наименование</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
                </thead>
                <tbody>
                    {rows}
                </tbody>
            </table>
        </>
    )
}